import { createContext, useContext } from 'react';

export type SetupTourControls = {
  activeTourId: string | null;
  isTransitioning: boolean;
  startTour: (tourId: string) => void;
  next: () => Promise<void>;
  goToStep: (stepId: string) => Promise<void>;
  previous: () => Promise<void>;
  close: () => void;
};

export const SetupTourContext = createContext<SetupTourControls | null>(null);

export const useSetupTourRuntime = (): SetupTourControls => {
  const controls = useContext(SetupTourContext);
  if (!controls) {
    throw new Error('useSetupTourRuntime must be used within a SetupTourProvider');
  }

  return controls;
};
